<template>
  <!-- 添加佣金弹窗 -->
  <a-modal
    :visible="commissionVisible"
    :title="commissionTitle"
    :maskClosable="false"
    @cancel="handleCancel"
    :footer="null"
  >
    <a-form-model style="margin-left: 20px" ref="commissionForm" :model="commissionForm" :rules="rules">
      <a-form-model-item prop="commissionType">
        <a-select :disabled="isdisabled" v-model="commissionForm.commissionType" placeholder="请选择佣金类型">
          <a-select-option v-for="item in commissionTypeList" :key="item.dictValue" :value="item.dictValue">
            {{ item.dictLabel }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item ref="commissionFee" prop="commissionFee">
        <a-input
          placeholder="金额"
          :maxLength="10"
          v-model="commissionForm.commissionFee"
          @input="numValidate('commissionForm.commissionFee')"
        />
      </a-form-model-item>
      <a-form-model-item prop="commissionRemark" v-if="commissionTitle == '冲红'">
        <a-textarea v-model="commissionForm.commissionRemark" placeholder="备注" allow-clear />
      </a-form-model-item>
      <a-form-model-item :wrapper-col="{ span: 10, offset: 10 }">
        <a-button type="primary" style="background: var(--ThemeColor)" @click="commissionOnSubmit"> 确定 </a-button>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
export default {
  props: {
    commissionTypeList: {
      type: Array,
      default: () => [],
    },
    contractId: {
      type: [String, Number],
      default: '',
    },
    isdisabled: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    commissionTypeList: {
      handler() {},
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      commissionVisible: false,
      commissionTitle: '添加佣金',
      commissionForm: {
        commissionType: undefined,
        commissionFee: '',
        commissionRemark: '',
      },
      rules: {
        commissionType: [{ required: true, message: '请选择佣金类型', trigger: 'change' }],
        commissionFee: [{ required: true, message: '请输入金额', trigger: 'blur' }],
      },
    }
  },
  methods: {
    // num验证
    numValidate(fieldName) {
      const val = fieldName === 'commissionForm.commissionFee' ? this.commissionForm.commissionFee : null
      const reg = /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/
      if (!reg.test(val)) {
        this.commissionForm.commissionFee = ''
      }
    },
    handleCancel() {
      this.commissionVisible = false
    },
    commissionOnSubmit() {
      this.$emit('submit', this.commissionForm)
    },
  },
}
</script>

<style lang="less" scoped></style>
